import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface OutlineButtonProps
  extends React.ComponentProps<typeof Button> {
  icon?: React.ReactNode;
  label: string;
}

export default function OutlineButton({
  className,
  icon,
  label,
  ...rest
}: OutlineButtonProps) {
  return (
    <Button
      className={cn(
        "flex items-center gap-1.5 rounded-full border border-white/50 px-2.5 py-1 font-medium text-12 text-white shadow-white/10 transition-[colors,shadow]",
        "hover:bg-white/10 hover:shadow-0-0-10",
        className
      )}
      {...rest}
    >
      {icon}
      <span>{label}</span>
    </Button>
  );
}
